module.exports = {
  enlabelEndpoint: "https://enlabel.herokuapp.com/api/",
  personalizedEndpoint: "https://j4zae6wt0c.execute-api.us-east-1.amazonaws.com/prod/signature",
  contactUsSigEndpoint: "https://lgy506hpcj.execute-api.us-west-2.amazonaws.com/prod/signature/",
  contactUsTicketEndpoint: "https://lgy506hpcj.execute-api.us-west-2.amazonaws.com/prod/ticket/",
  integrityEndpoints: {
    eGiftcardRequest: "https://hooks.zapier.com/hooks/catch/5182984/oyjb5ld/",
    discountCodeRequest: "https://hooks.zapier.com/hooks/catch/5182984/oyjo0tp/",
  }
}